// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".face_width_btn{width:100%}.fcb_mx-width{max-width:180px!important}.height_mob_fb{height:63%}@media (max-width:700px){.face_width_btn{width:102.5%}}@media (max-width:420px){.pl_resp_cd{padding-left:4px!important}.resp_cd{font-size:68%!important}}@media (max-width:325px){.fcb_mx-width{max-width:170px!important;position:relative;left:-5px}}@media (max-width:300px){.fcb_mx-width{max-width:165px!important;position:relative;left:-10px}}", ""]);
// Exports
module.exports = exports;
